<!-- <div class="row">
  <div class="col-md-2" style="margin: auto;" *ngIf="objectKeys(validationErrors).length > 0">
    <span class="segment-title" style="color: #FF0000;">Oops!</span>
    <br>
    <span class="err-text">An error has occurred!</span>
  </div> -->
  <ul class="err-list col" >
    <ng-container *ngFor="let item of mapValidationErrorsToArray()">
      <li *ngIf="isDesktop" (click)="focusControl(item.key)">
        <mat-error class="error-message" >
          ❋ {{getMessageValidator(item)}}
        </mat-error>
      </li>
      <li *ngIf="!isDesktop" >
        <mat-error class="error-message" >
          ❋ {{getMessageValidator(item)}}
        </mat-error>
      </li>
    </ng-container>
  </ul>
  <!-- <ul class="err-list col">
    <ng-container *ngFor="let item of validationErrors | keyvalue; let i = index;">
      <li *ngIf="i >= (objectKeys(validationErrors).length/2)">
        <mat-error class="error-message" (click)="focusControl(item.key)">
          ❋ {{util.getErrorMessage(item)}}
        </mat-error>
      </li>
    </ng-container>
  </ul> -->
<!-- </div> -->
